import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { useTheme, ThemeProvider } from "@mui/material/styles";
import { lightTheme, useStyles } from "../../assets/styles/Theme";

function GrnPdfSupplier({ grnHeader, selectedSupplier }) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const supplierData = grnHeader || selectedSupplier || {};

  return (
    <ThemeProvider theme={lightTheme}>
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle_s"
          fontWeight="bold"
          sx={{ mb: 1 }}
        >
          SUPPLIER INFORMATION
        </Typography>

        <TableContainer component={Paper} sx={{ boxShadow: "none" }} mt={2}>
          <Table
            size="small"
            aria-label="Supplier information"
            sx={{
              "& td, & th": { borderBottom: "none", paddingY: 0.6 },
            }}
          >
            <TableBody>
              {/* SUPPLIER CODE */}
              <TableRow>
               <TableCell sx={{ width: "10%" }} >
                  <Typography variant="body_xs" fontWeight="bold">
                    SUPPLIER CODE
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body_xs">
                    {supplierData.suprefcode ||
                      supplierData.optSupplierRefCode ||
                      "N/A"}
                  </Typography>
                </TableCell>
              </TableRow>

              {/* NAME */}
              <TableRow>
                <TableCell>
                  <Typography variant="body_xs" fontWeight="bold">
                    NAME
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body_xs">
                    {supplierData.suppliername ||
                      supplierData.optSupplierName ||
                      "N/A"}
                  </Typography>
                </TableCell>
              </TableRow>

              {/* ADDRESS */}
              <TableRow>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Typography variant="body_xs" fontWeight="bold">
                    ADDRESS
                  </Typography>
                </TableCell>
             <TableCell sx={{ width: "10%" }}>
  <Typography variant="body_xs">
    {[
      supplierData.addresslinE1 || supplierData.optSupplieraddressline1,
      supplierData.addresslinE2 || supplierData.optSupplieraddressline2,
      supplierData.addresslinE3 || supplierData.optSupplieraddressline3,
      supplierData.city || supplierData.optSupplierCity,
      supplierData.province || supplierData.optSupplierProvince,
      supplierData.country || supplierData.optSupplierCountry,
    ]
      .filter(Boolean)
      .join(", ") || "-"}
  </Typography>
</TableCell>

              </TableRow>

              {/* CONTACT / PHONE */}
              <TableRow>
                <TableCell>
                  <Typography variant="body_xs" fontWeight="bold">
                    CONTACT / PHONE
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body_xs">
                    {supplierData.contactno ||
                      supplierData.contactNo ||
                      "N/A"}
                  </Typography>
                </TableCell>
              </TableRow>

              {/* EMAIL */}
              <TableRow>
                <TableCell>
                  <Typography variant="body_xs" fontWeight="bold">
                    EMAIL
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body_xs">
                    {supplierData.email || "N/A"}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </ThemeProvider>
  );
}

export default GrnPdfSupplier;
